const styles = () => ({
  cellFocus: {
    cursor: "pointer",
    width: "20vw",
  },
  dialogRoot: {
    minWidth: 400,
    minHeight: 20,
    paddingBottom: 2,
  },
  dialogContentContainer: {
    display: "flex",
    flexDirection: "column",
  },
  dialogTitle: {
    marginBottom: 0,
    fontWeight: "bold",
    marginTop: -32,
    width: "85%",
  },
  dialogContent: {
    padding: 20,
    fontSize: 16,
  },
  dialogFooter: {
    display: "flex",
    justifyContent: "flex-end",
    paddingTop: 6,
  },
  dialogButtons: {
    display: "flex",
    flexWrap: "wrap-reverse",
    justifyContent: "flex-end",
  },
  dialogButton: {
    marginRight: 10,
    fontSize: 14,
  },
  rowContainer: {
    display: "flex",
    alignItems: "center",
  },
  dialogSelectField: {
    "& .MuiOutlinedInput-root": {
      minHeight: "52px",
      display: "flex",
      alignItems: "center",
    },
    "& .MuiSelect-select": {
      minHeight: "32px",
      padding: "10px 14px",
      display: "flex",
      alignItems: "center",
    },
    "& .MuiInputBase-input": {
      padding: "10px 14px",
    },
  },
  dialogTextField: {
    "& .MuiOutlinedInput-root": {
      minHeight: "52px",
      display: "flex",
      alignItems: "center",
    },
    "& .MuiInputBase-input": {
      padding: "10px 14px",
    },
  },
  dialogInputField: {
    "& .MuiInputBase-input": {
      padding: "10px 14px",
      minHeight: "20px",
    },
  },
  dialogFormBox: {
    marginBottom: 3,
  },
});

export default styles;
